import { openMangoWidget } from '~/composables/openMangoWidget';

/** Телефон для запасного действия кнопок ФОС (как в 110381). */
export const FEEDBACK_PHONE_LINK = 'tel:+74950550303';

/** Запасное действие по умолчанию: набрать номер. */
export const dialFeedbackPhone = (): void => {
  if (process.client) {
    window.location.href = FEEDBACK_PHONE_LINK;
  }
};

/**
 * Единый триггер обратной связи: сначала пробуем открыть виджет Манго, а если он
 * не открылся — делаем то, что кнопка делала по умолчанию (`fallback`).
 *
 * @param fallback дефолтное поведение кнопки; по умолчанию — звонок на телефон центра
 */
export const useFeedbackWidget = (fallback: () => void = dialFeedbackPhone) => {
  const open = async (): Promise<void> => {
    if (await openMangoWidget()) {
      return;
    }

    fallback();
  };

  return { open };
};
